<div class="container pt-5 mt-5">
  <div class="shadow p-3 mb-5 bg-white rounded">
    <app-term-and-condition></app-term-and-condition>
  </div>
</div>